import { createClient } from '@supabase/supabase-js'

// Read Supabase URL and Anon Key from environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Basic check to ensure environment variables are loaded
if (!supabaseUrl) {
  console.error('Error: REACT_APP_SUPABASE_URL is not defined. Make sure it is set in your .env file.');
  throw new Error('Missing Supabase URL environment variable');
}

if (!supabaseAnonKey) {
  console.error('Error: REACT_APP_SUPABASE_ANON_KEY is not defined. Make sure it is set in your .env file.');
  throw new Error('Missing Supabase Anon Key environment variable');
}

// Create and export the Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Optional: Add a health check function or further configuration if needed
console.log('Supabase client initialized.'); 